// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__6IGeo","rootCenter":"LoadMoreObserver_rootCenter__1EED8","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__22Cg4"};